<template>
    <div v-if="active && showOverlay" class="upload-overlay">
        <div class="upload-modal">
            <div class="text-center mb-5">
                {{ title }}
            </div>

            <v-progress-linear
                :value="progress"
                height="20"
                color="red"
            >
                <strong class="progress-text">
                    {{ Math.ceil(progress) }}%
                </strong>
            </v-progress-linear>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
            type: Boolean,
            default: false
        },
        progress: {
            type: Number,
            default: 0
        },
        fileSize: {
            type: Number,
            default: 0
        },
        filesCount: {
            type: Number,
            default: 1
        }
    },

    computed: {
        showOverlay() {
            return this.fileSize > 25 * 1024 * 1024;
        },

        title() {
            if (this.filesCount > 1) {
                return `Uploading ${this.filesCount} files...`;
            }

            return 'Uploading file...';
        }
    }
}
</script>

<style scoped>
.upload-overlay {
    position: absolute;
    inset: 0;
    background: rgba(0,0,0,0.4);
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    pointer-events: all;
}

.upload-modal {
    background: white;
    padding: 15px;
    border-radius: 4px;
    width: 420px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
}

.progress-text {
    color: white;
}
</style>
